import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import {
  checkValidCredentialsRequest,
  credentialsRequest,
  credentialsUpdateRequest,
  credentialsDeleteRequest,
} from '@store/apiSettings/credentials';
import { marketplacesRequest } from '@store/apiSettings/marketplaces';

export default all([
  /* @ts-expect-error This will error until handleRequest has been converted to TS */
  takeLatest(credentialsRequest.type, handleRequest),
  /* @ts-expect-error This will error until handleRequest has been converted to TS */
  takeLatest(marketplacesRequest.type, handleRequest),
  /* @ts-expect-error This will error until handleRequest has been converted to TS */
  takeLatest(credentialsUpdateRequest.type, handleRequest),
  /* @ts-expect-error This will error until handleRequest has been converted to TS */
  takeEvery(checkValidCredentialsRequest.type, handleRequest),
  /* @ts-expect-error This will error until handleRequest has been converted to TS */
  takeEvery(credentialsDeleteRequest.type, handleRequest),
]);
